// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--caPuj","image":"_02712f2b3b--image--MzU09","message":"_02712f2b3b--message--oVZ_W","button-wrapper":"_02712f2b3b--button-wrapper--pLBjp"};